const IP_DOMAIN_URL = "plataformaip.lex.com.br";

export function getIsIpDomain(): boolean {
  const { hostname } = window.location;

  return hostname === IP_DOMAIN_URL || hostname.endsWith(`.${IP_DOMAIN_URL}`);
}
